module.exports = __webpack_public_path__ + "static/media/ipk2022_Branding.007.b82f9f1c.jpeg";